import { render } from "./HeroiconsSolidClipboardList.vue?vue&type=template&id=74787424"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidClipboardList.vue"]])

export default __exports__